<template>
  <Modal
    size="sm"
    @close="$emit('close')"
  >
    <template #header>
      <div class="w-full text-center">
        <h1 class="text-2xl">
          {{ $t('Reports.MonthlyFinancials.exportMonthlyReport') }}
        </h1>
      </div>
    </template>

    <template #body>
      <div class="flex justify-center w-full flex-col space-y-4">
        <label>
          {{ $t('Reports.MonthlyFinancials.month') }}

          <AppInput
            v-model="reportMonth"
            name="month"
            type="month"
            class="form-input"
          />
        </label>
      </div>
    </template>

    <template #footer>
      <div class="flex justify-end">
        <button
          type="button"
          class="btn btn--tertiary-blue"
          @click.prevent="$emit('close')"
        >
          {{ $t('Reports.MonthlyFinancials.button.close') }}
        </button>

        <button
          type="button"
          class="btn btn--primary-blue ml-2"
          @click="exportMonthlyReport"
        >
          {{ $t('Reports.MonthlyFinancials.button.exportReport') }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Modal from '@/components/Modal.vue';
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { dateForMonthInput } from '@/helpers';
import { t } from '@/i18n';
import { useProjectsStore } from '@/store/projects';
import Swal from 'sweetalert2';
import { computed, ref, watch } from 'vue';

const emits = defineEmits<{
  (e: 'close');
}>();

const reportMonth = ref(dateForMonthInput(new Date()));
const projectsStore = useProjectsStore();

const project = computed(() => {
  return projectsStore.project;
});

const exportMonthlyReportAction = useStoreApiAction(projectsStore.monthlyReport);

const exportMonthlyReport = () => {
  exportMonthlyReportAction.request(project.value.id, { month: reportMonth.value }).then(() => {
    Swal.fire({
      icon: 'success',
      title: t('Reports.MonthlyFinancials.monthlyReportGenerating'),
      text: t('Reports.MonthlyFinancials.emailNotification'),
    }).then(() => {
      emits('close');
    });
  }).catch((error) => {
    if(error.status === 429) {
      Swal.fire({
        icon: 'error',
        title: t('Reports.MonthlyFinancials.pdfCurrentlyExporting'),
        text: error.data.message,
      });
    } else if(error.status === 422) {
      Swal.fire({
        icon: 'error',
        title: t('Reports.MonthlyFinancials.failedToExport'),
        text: error.data.message,
      });
    }
  });
};
</script>

<style scoped></style>
